import { Component } from '@angular/core';

@Component({
  selector: 'app-faculty-link',
  templateUrl: './faculty-link.component.html',
  styleUrls: ['./faculty-link.component.scss']
})
export class FacultyLinkComponent {

}
